import React from "react";
import styled from "styled-components";

import { reactKeyFromIDSK } from "@examspark/common";
import { Resource } from "@examspark/types";

import { useLineReader } from "../../utils/useLineReader";
import AccessibilityWrapper from "../exam/AccessibilityWrapper";
import Modal, { ModalProps } from "../modal/Modal";

import { ContextWrapper } from "./ItemContextSidebar";

export const ItemContexts = styled.div`
  flex: 1;
  padding: 1rem;
  overflow: auto;
  height: 100%;

  & > div {
    border-top: solid 1px #ddd;
    margin-top: 1em;
    padding-top: 1em;
  }
  & > div:first-child {
    border-top: none;
    margin-top: 0;
    padding-top: 0;
  }
`;

type ItemContextModalProps = ModalProps & {
  contexts: Resource[];
};
const ItemContextModal = (props: ItemContextModalProps) => {
  const { contexts, ...modalProps } = props;

  return (
    <Modal {...modalProps}>
      <ItemContextModalInner contexts={contexts} />
    </Modal>
  );
};

const ItemContextModalInner = (props: { contexts: Resource[] }) => {
  const { contexts } = props;

  const { handleClick, containerRef } = useLineReader();

  return (
    <AccessibilityWrapper>
      <div
        style={{ padding: "1rem", position: "relative" }}
        ref={containerRef}
        onClick={handleClick}
      >
        <ItemContexts>
          {contexts?.map((ctx) => {
            return <ContextWrapper key={reactKeyFromIDSK(ctx)} data={ctx} />;
          })}
        </ItemContexts>
      </div>
    </AccessibilityWrapper>
  );
};

export default ItemContextModal;
